module.exports = __webpack_public_path__ + "static/media/americanExp.afbb2152.svg";